import { systemConfig } from 'defaultconfig'
import request from '@/utils/request'

export function getNav (params) {
    return request({
      url: systemConfig.requestApi + '/api/NavInfo',
      method: 'get',
      params: params
    })
  }
  export function getfoot (params) {
    return request({
      url: systemConfig.requestApi + '/api/DictInfo',
      method: 'get',
      params: params
    })
  }